import { Action } from '@ngrx/store';


export enum EAllergenActions {
    GetAllergen = '[Allergen] Get Allergen',
    GetAllergenDetails = '[Allergen] Set Allergen Details',
    AddAllergen = '[Allergen] Add Allergen',
    // EditAllergen = '[Allergen] Edit Allergen',
    SetAllergenSuccess = 'Set Allergen Success',
    SetAllergenError = 'Set Allergen Error',
    EditAllergen = '[Allergen] Edit Allergen',
    GetEditAllergenSuccess = '[Allergen] Get Edit Allergen Success',
    GetEditAllergenError = '[] Get Edit Allergen Error',

}

export class GetAllergen implements Action {
    public readonly type = EAllergenActions.GetAllergen;
    constructor(public payload: any) {}
}

export class GetAllergenDetails implements Action {
    public readonly type = EAllergenActions.GetAllergenDetails;
    constructor(public payload: any) {
    }
}

export class AddAllergen implements Action {
    public readonly type = EAllergenActions.AddAllergen;
    constructor(public payload: any) {
    }
}

export class SetAllergenSuccess implements Action {
    public readonly type = EAllergenActions.SetAllergenSuccess;
    constructor(public payload: any, public from: any) {
    }
}

export class SetAllergenError implements Action {
    public readonly type = EAllergenActions.SetAllergenError;
    constructor(public payload: any, public from: any) {
    }
}
export class EditAllergen implements Action {
    public readonly type = EAllergenActions.EditAllergen;
    constructor(public payload: any) {
    }
}
export class GetEditAllergenSuccess implements Action {
    public readonly type = EAllergenActions.GetEditAllergenSuccess;
    constructor(public payload: any) {
    }
}
export class GetEditAllergenError implements Action {
    public readonly type = EAllergenActions.GetEditAllergenError;
    constructor(public payload: any) {
    }
}

export type AllergenAction =  GetAllergen | GetAllergenDetails | SetAllergenSuccess | SetAllergenError | AddAllergen
                                 | EditAllergen | GetEditAllergenSuccess| GetEditAllergenError;